<template>
  <WLPopover
    ref="popOverRef"
    :placement
    :anchor
    :size
    :arrow-offset
    :has-teleport
    :margin
    :padding
    :trigger
    :is-open
    :has-arrow
    :container-classes="`[filter:drop-shadow(0_0_1px_rgb(0_0_0_/_0.25))_drop-shadow(0_2px_1px_rgb(0_0_0_/_0.05))] rounded-2xl ${containerClasses}`"
    @update:is-open="emit('update:isOpen', $event)"
  >
    <template v-if="$slots.anchor" #anchor>
      <slot name="anchor" />
    </template>
    <template #content="{ close: closePopover }">
      <div
        class="wl-tooltip relative flex flex-col"
        :class="[
          { 'p-3': content.title && content.description },
          { 'px-2 py-1.5': content.title && !content.description },
        ]"
      >
        <WLButton
          v-if="content.hasClose"
          ref="closeButtonRef"
          class="absolute right-5 top-5"
          :size="ButtonSize.EXTRA_SMALL"
          :variant="ButtonVariant.ELEVATED"
          :icon="IconName.CONTROLS_CLOSE"
          @click="
            () => {
              closePopover();
              emit('close');
            }
          "
        />
        <img
          v-if="content.image"
          ref="imageRef"
          class="mb-3 max-h-40 rounded bg-muted"
          :alt="content.title"
          :title="content.title"
          :src="content.image"
        />
        <p
          v-if="content.title"
          ref="titleRef"
          class="title text-sm font-medium text-emphasis"
        >
          {{ content.title }}
        </p>
        <!-- TODO: would be nice if we supported lists here as well. -->
        <p
          v-if="content.description"
          ref="descriptionRef"
          class="description mt-1 whitespace-pre-line text-sm font-normal text-muted"
        >
          {{ content.description }}
        </p>
      </div>
    </template>
  </WLPopover>
</template>
<script setup lang="ts">
import { type WLTooltipProps, type WLTooltipEmits } from "./types";
import { PopoverTrigger, WLPopover } from "../popover";
import { ButtonSize, ButtonVariant, WLButton } from "../button";
import { IconName } from "../icon";
import { TooltipSize } from "./constants";

const emit = defineEmits<WLTooltipEmits>();
const {
  content,
  isOpen,
  hasArrow = true,
  hasTeleport = false,
  arrowOffset = 4,
  size = TooltipSize.SMALL,
  placement = "bottom",
  trigger = PopoverTrigger.HOVER,
  margin = 6,
  padding,
  containerClasses,
} = defineProps<WLTooltipProps>();
</script>
